import { render, staticRenderFns } from "./footerCommon.vue?vue&type=template&id=6bfcbe3d&scoped=true&"
import script from "./footerCommon.vue?vue&type=script&lang=js&"
export * from "./footerCommon.vue?vue&type=script&lang=js&"
import style0 from "./footerCommon.vue?vue&type=style&index=0&id=6bfcbe3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfcbe3d",
  null
  
)

export default component.exports